<template>
 <div class="fc-page mg-page rp-page rp-student_count">
  <nav aria-label="面包屑"><v-breadcrumbs :items="breadcrumbs" divider="/" class="mg-breadcrumb" /></nav>
  <header class="fc-heading"><div><h1>学员报表</h1><p>查看学员增长趋势，了解生源与区域分布</p></div><span class="rp-heading-symbol" aria-hidden="true"><v-icon size="25" color="#d9363e">mdi-chart-box-outline</v-icon></span></header>
  <section class="fc-filters rp-year-filters" aria-label="统计年份筛选"><div class="fc-filter-heading"><h3>统计范围</h3><span>选择年份后查询</span></div><form class="rp-year-form" @submit.prevent="refresh"><div class="fc-filter-cell"><v-select :items="yearItems" v-model="query.year" item-text="name" item-value="value" label="年份" dense outlined hide-details color="#d9363e" /></div><v-btn type="submit" depressed color="#d9363e" dark><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></form></section>
  <div class="rp-chart-grid">
   <article class="rp-chart"><div class="rp-chart-heading"><div><h3>月新增学员</h3><p>按月查看学员增长情况</p></div></div><div class="rp-chart-body"><ve-histogram v-if="chartData.rows.length" :data="chartData" :colors="['#d9363e','#6087b1','#6ca68e','#d6ab68','#9b87af']" :judge-width="true" height="360px" :extend="Object.assign({}, chartExtend, {title:{show:false},textStyle:{fontFamily:'Microsoft YaHei',color:'#718096'},'legend.textStyle':{color:'#718096'}})" /><div v-else class="rp-chart-empty" role="status"><v-icon size="32">mdi-chart-box-outline</v-icon><h4>暂无统计数据</h4><p>当前查询范围内暂无可展示的记录</p></div></div><div v-if="summaryText" class="rp-chart-summary">{{summaryText}}</div></article>
   <article class="rp-chart"><div class="rp-chart-heading"><div><h3>生源类型占比 TOP5</h3><p>了解主要招生来源</p></div></div><div class="rp-chart-body"><ve-pie v-if="sourceTypeData.rows.length" :data="sourceTypeData" :colors="['#d9363e','#6087b1','#6ca68e','#d6ab68','#9b87af']" :judge-width="true" height="360px" :extend="Object.assign({}, {}, {title:{show:false},textStyle:{fontFamily:'Microsoft YaHei',color:'#718096'},'legend.textStyle':{color:'#718096'}})" :settings="sourceTypeSettings" /><div v-else class="rp-chart-empty" role="status"><v-icon size="32">mdi-chart-box-outline</v-icon><h4>暂无统计数据</h4><p>当前查询范围内暂无可展示的记录</p></div></div></article>
   <article class="rp-chart"><div class="rp-chart-heading"><div><h3>就读学校分布 TOP5</h3><p>查看学员就读学校分布</p></div></div><div class="rp-chart-body"><ve-pie v-if="fromSchoolData.rows.length" :data="fromSchoolData" :colors="['#d9363e','#6087b1','#6ca68e','#d6ab68','#9b87af']" :judge-width="true" height="360px" :extend="Object.assign({}, {}, {title:{show:false},textStyle:{fontFamily:'Microsoft YaHei',color:'#718096'},'legend.textStyle':{color:'#718096'}})" :settings="fromSchoolSettings" /><div v-else class="rp-chart-empty" role="status"><v-icon size="32">mdi-chart-box-outline</v-icon><h4>暂无统计数据</h4><p>当前查询范围内暂无可展示的记录</p></div></div></article>
   <article class="rp-chart"><div class="rp-chart-heading"><div><h3>居住片区分布 TOP5</h3><p>查看学员居住片区分布</p></div></div><div class="rp-chart-body"><ve-bar v-if="fromRegionData.rows.length" :data="fromRegionData" :colors="['#d9363e','#6087b1','#6ca68e','#d6ab68','#9b87af']" :judge-width="true" height="360px" :extend="Object.assign({}, regionExtend, {title:{show:false},textStyle:{fontFamily:'Microsoft YaHei',color:'#718096'},'legend.textStyle':{color:'#718096'}})" /><div v-else class="rp-chart-empty" role="status"><v-icon size="32">mdi-chart-box-outline</v-icon><h4>暂无统计数据</h4><p>当前查询范围内暂无可展示的记录</p></div></div></article>
  </div>
 </div>
</template>

<script>
	import utils from "../../../config/utils"
	export default {
		name: "student-dashboard",
		data() {
			this.chartExtend = {
			  
			  series: {
				barWidth: 40,
				label:{show:true,position:'top'}
			  }
			},
			this.sourceTypeSettings = {
				//roseType: 'radius'
			},
			this.fromSchoolSettings = {
				type:'pie',
			},
			this.regionExtend={
				series: {
					barWidth: 40,
					label:{show:true,position:'right'}
				}
			}
			return {
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '数据报表',
						disabled: true
					},
					{
						text: '学员报表',
						disabled: true
					},
				],
				shopId:"",
				yearItems:[],
				chartData: {
					columns: ['月份', '新增学员数'],
					rows: [],
				},
				summaryText:"",
				query: {
					year:""+new Date().getFullYear()
				},
				sourceTypeData:{
					columns: ['类型名称', '学员数'],
					rows: [],
				},
				fromSchoolData:{
					columns: [],
					rows: [],
				},
				fromRegionData:{
					columns: [],
					rows: [],
				}
			}
		},
		mounted() {
			this.generateYearItems();
		},
		created() {
			this.shopId = utils.getCurrentShopId();
			
			this.refresh();
		},
		
		methods: {
			refresh(){
				this.getChartData();
				// 获取生源类型占比
				this.getStudentFromChartData("1");
				// 获取就读学校占比
				this.getStudentFromChartData("2");
				// 获取居住片区占比
				this.getStudentFromChartData("3");
			},
			generateYearItems(){
				let fromYear = 2018;
				const now = new Date();
				const nowYear = now.getFullYear();
				
				for (let i = fromYear; i <= nowYear; i++) {
					this.yearItems.push({value:i.toString(),name:i.toString()+"年"})
				}
			},
			getChartData() {

				const that = this;

				let url = `/report/student/count/dashboard/${this.query.year}?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				
				this.axios.get(url).catch(()=>{
					return;
				}).then(response => {
					
				
					if (response.data["code"] === 200) {
						
						console.log(response.data["data"]);
						
						that.chartData.columns = response.data["data"]["labels"] ? response.data["data"]["labels"] : [];
						that.chartData.rows = response.data["data"]["dataList"]? response.data["data"]["dataList"] : [];
						that.summaryText  =  response.data["data"]["summaryText"];
						
						return
					}

				})
			},
			getStudentFromChartData(dataType) {
			
				const that = this;
			
				let url = `/report/student/from/count/${dataType}?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				if(this.query.year){
					url += "&year=" + this.query.year;
				}
				
				console.log(url);
				this.axios.get(url).catch(()=>{
					return;
				}).then(response => {
					
				
					if (response.data["code"] === 200) {
						
						console.log(response.data["data"]);
						if (dataType == '1'){
							that.sourceTypeData.columns = response.data["data"]["labels"] ? response.data["data"]["labels"] : [];
							that.sourceTypeData.rows = response.data["data"]["dataList"]? response.data["data"]["dataList"] : [];
							
						}else if (dataType =='2'){
							that.fromSchoolData.columns = response.data["data"]["labels"] ? response.data["data"]["labels"] : [];
							that.fromSchoolData.rows = response.data["data"]["dataList"]? response.data["data"]["dataList"] : [];
						}else if (dataType =='3'){
							that.fromRegionData.columns = response.data["data"]["labels"] ? response.data["data"]["labels"] : [];
							that.fromRegionData.rows = response.data["data"]["dataList"]? response.data["data"]["dataList"] : [];
						}
						
						
						
						return
					}
			
				})
			},
			
			
		}
	}
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/reports-management.scss";
</style>
